import axios from 'axios';

class ArticlesAPI {
  constructor() {
    this.baseUrl = '';
  }

  searchArticles(
    portalSlug = 'centro-de-ayuda',
    locale = 'es',
    query = null,
    truncate = false,
    limit = null,
    summary = false
  ) {
    if (this.baseUrl === '') {
      this.baseUrl = window.location.origin;
    }
    if (locale === '') {
      locale = 'es';
    }
    let baseUrl = `${this.baseUrl}/hc/${portalSlug}/${locale}/articles.json?query=${query}`;
    if (truncate) {
      baseUrl = `${baseUrl}&truncate=true`;
    }
    if (limit) {
      baseUrl = `${baseUrl}&limit=${limit}`;
    }
    if (summary) {
      baseUrl = `${baseUrl}&summary=true`;
    }
    return axios.get(baseUrl);
  }
}

export default new ArticlesAPI();
